import types from './actionTypes';
import { addOrReplaceObjectInArray } from '../../../helpers/reducerHelper';

const initialState = {
  loading: false,
  videoContents: [],
  error: '',
};

const videoContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_VIDEO_CONTENT_STATE:
      return initialState;
    case types.CREATE_VIDEO_CONTENT.REQUEST:
    case types.UPDATE_VIDEO_CONTENT.REQUEST:
    case types.FETCH_VIDEO_CONTENT.REQUEST:
    case types.SYNC_VIDEO_CONTENTS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_VIDEO_CONTENT.SUCCESS:
    case types.UPDATE_VIDEO_CONTENT.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.FETCH_VIDEO_CONTENT.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        videoContents: action.videoContent
          ? addOrReplaceObjectInArray(
              state.videoContents,
              action.videoContent,
              'id',
            )
          : state.videoContents,
      };
    case types.SYNC_VIDEO_CONTENTS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        videoContents: [...action.videoContents],
      };
    case types.CREATE_VIDEO_CONTENT.FAILURE:
    case types.UPDATE_VIDEO_CONTENT.FAILURE:
    case types.FETCH_VIDEO_CONTENT.FAILURE:
    case types.SYNC_VIDEO_CONTENTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default videoContentReducer;
